export default __webpack_public_path__ + "6788408c5879bc449eb46271601ac893.png";